import React from 'react'
import { Paper } from '@mui/material'
import { ColDef } from 'ag-grid-community'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling'

export const AGDataGridRowDetails = (props: any) => {
    const { clientTheme } = useThemeStyling()

    const {
        data: rowData,
        gridName,
        rowDetailsContainerHeight,
        rowDetailsFilteredColumns,
        handleFormatRowDetailsValue,
    } = props

    return (
        <Paper
            className="emp-agDataGridRowDetails-gridContainer"
            style={{
                height: rowDetailsContainerHeight - 20,
                fontSize: clientTheme.typography.body1.fontSize,
            }}
        >
            {rowDetailsFilteredColumns.map((col: ColDef, idx: number) => {
                const formattedValue = handleFormatRowDetailsValue(
                    col.field,
                    rowData
                )
                let isInvalidField = false

                if (gridName === 'invalidChargebacks') {
                    isInvalidField = rowData.invalid_fields?.includes(col.field)
                }

                return (
                    <div
                        className="emp-agDataGridRowDetails-fieldContainer"
                        key={`key-${col.headerName}-${idx}`}
                    >
                        <div className="emp-agDataGridRowDetails-labelContainer">
                            {col.headerName}:
                        </div>
                        <div
                            className={`${
                                isInvalidField &&
                                'emp-agDataGridRowDetails-invalidField'
                            }`}
                        >
                            {formattedValue}
                        </div>
                    </div>
                )
            })}
        </Paper>
    )
}
